import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import SimpleMenuItem from '../SimpleMenuItem';

import { IndustrySubMenuFooterContainer } from './styles';

const IndustrySubMenuFooter = ({ footerItem }) => {
  return (
    <IndustrySubMenuFooterContainer>
      <SimpleMenuItem type="footer" title={footerItem.label} link={footerItem.url} />
      <div className="industry-sub-menu--footer-demo">
        <p>Book a personalized</p>
        <HyperLink href="/demo">demo today</HyperLink>
      </div>
    </IndustrySubMenuFooterContainer>
  );
};

export default IndustrySubMenuFooter;
